import { FieldsConfigResponse } from "@hooks/use-config-context/types";
import { TICKET_KEY_FOR_ASSETS } from "./types";
import { buildSubFieldsConfig } from "./format-utils";

export const formatTicketForSave = (
  toSave: Record<string, any>,
  config: FieldsConfigResponse,
) => {
  const subFieldsConfig = buildSubFieldsConfig(config);

  let meta_box = {} as Record<string, any>;

  Object.entries(toSave).forEach(([key, value]) => {
    if (key === "id" || key === "ticket_id" || key === "title") {
      return; // Skip fields
    }  

    if(key === TICKET_KEY_FOR_ASSETS) {
      // Handle both string and array formats
      const valueArray = Array.isArray(value) ? value : (value ? [value] : []);
      // Convert array objects with id to just the id values
      meta_box[key] = valueArray.map((val) => {
        // If it's an object with an id property, extract the id
        if (typeof val === "object" && val.id) {
          return val.id;
        }
        // Otherwise return the value as-is
        return val;
      });
      return;
    }

    const fieldConfig = (config[key] || subFieldsConfig[key]) as any;
    if (fieldConfig && !(fieldConfig as any).parentFieldId) {
      meta_box[key] = value;
    } else if (fieldConfig && fieldConfig.parentFieldId) {
      meta_box[fieldConfig.parentFieldId] = {
        ...(meta_box[fieldConfig.parentFieldId] || {}),
        [key]: value,
      };
    }
  });
  const toSaveData = {
    meta_box,
  } as Record<string, any>;

  if (toSave.title) {
    toSaveData.title = toSave.title;
  }
  return toSaveData;
};
